/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const policyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnum = {
    EmployeeInternal: 'EmployeeInternal',
    ThirdPartyActorExternal: 'ThirdPartyActorExternal',
} as const;

export type PolicyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnumKey =
    (typeof policyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnum)[keyof typeof policyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnum];

export type PolicyComplianceEnumsViolationByEmployeeOrByThirdPartyOption =
    PolicyComplianceEnumsViolationByEmployeeOrByThirdPartyOptionEnumKey;
